import { Typography } from '@material-ui/core';

const NoDataTableComponent = () => {
  return (
    <div className="flex flex-col justify-center items-center">
      <img
        src={'assets/images/no_data.svg'}
        className="mb-16 m-8"
        width="180px"
        alt="data not found"
      />
      <Typography variant="subtitle1" className="text-gray-500 font-light text-center p-0">
        Kayıt Bulunamadı...
      </Typography>
    </div>
  );
};

export default NoDataTableComponent;
